import React from 'react';
import CUSTOMER_LOGOS from '../data/customerLogos';

const CustomerLogosSection = () => {
  if (!CUSTOMER_LOGOS.length) {
    return null;
  }

  return (
    <section className="customer-logos" aria-label="Trusted by">
      <p className="customer-logos-label">Trusted by</p>
      <ul className="customer-logos-grid">
        {CUSTOMER_LOGOS.map((logo) => (
          <li key={logo.src} className="customer-logo">
            <img src={logo.src} alt={logo.name} loading="lazy" />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default CustomerLogosSection;
